import { appDetailDataBigScreen, appDetailDataSmallScreen, fieldInformationData, headerData, resolveIngredientRateAndQuantity } from './reportFunctions'

import { DEFAULT_DISPLAY_VALUE } from './applicationReportConstants'

export function mapConsolidateApplicationApiData(apiData, uomPreference) {
    return mapSessionData()

    function mapSessionData() {
        const products = []
        apiData.coverageMaps.forEach((element) => {
            products.push(element.product.name)
        })

        apiData.sessions.sort((a, b) => new Date(a.startTime) - new Date(b.startTime))

        const sessionIndexes = {}
        apiData.sessions.forEach((element, index) => {
            if (sessionIndexes[element.product.name]) {
                sessionIndexes[element.product.name].push(index)
            }
            else {
                sessionIndexes[element.product.name] = [index]
            }
        })

        const doneProducts = []
        const allPageData = []
        products.forEach((product, index) => {
            if (!doneProducts.includes(product)) {
                const sessionsProduct = sessionsProductData(apiData, sessionIndexes[product])
                const productData = {
                    headerInfo: headerData(apiData, product),
                    subheaderInfo: subheaderData(apiData, sessionIndexes[product], sessionsProduct.applicationVolumeWeight, sessionsProduct.completedArea),
                    fieldInformation: fieldInformationData(apiData),
                    mapData: mapData(apiData, sessionIndexes[product], index),
                    applicationDetail: appDetailDataBigScreen(apiData, sessionIndexes[product], uomPreference),
                    applicationDetailSmallScreen: appDetailDataSmallScreen(apiData, sessionIndexes[product], uomPreference),
                    productInfo: productInfoData(apiData, sessionIndexes[product], sessionsProduct),
                    ingredientInfo: ingredientData(apiData, index, sessionsProduct),
                }
                doneProducts.push(product)
                allPageData.push(productData)
            }
        })

        return allPageData
    }

    function sessionsProductData(apiData, sessionIndexes) {
        let completedArea = 0
        let totalVolume = 0
        let totalWeight = 0
        let appVol
        let applicationVolumeWeight = {}
        let totalProduct = {}
        for (let i = 0; i < sessionIndexes.length; i++) {
            completedArea += apiData.sessions[sessionIndexes[i]].totalArea
            totalVolume += apiData.sessions[sessionIndexes[i]].product.totalVolume
            totalWeight += apiData.sessions[sessionIndexes[i]].product.totalWeight
        }

        if (totalVolume && completedArea) {
            appVol = totalVolume / completedArea
            applicationVolumeWeight = {
                item: 'Avg. App Rate',
                value: appVol || DEFAULT_DISPLAY_VALUE,
                isUOM: true,
                metricUnits: 'L/ha',
                imperialUnits: 'gal/ac',
                baseUnits: 'L/m2',
                precision: 2,
                allowTruncate: false,
            }
            totalProduct = {
                item: 'Total Product',
                value: totalVolume || DEFAULT_DISPLAY_VALUE,
                isUOM: true,
                metricUnits: 'L',
                imperialUnits: 'gal',
                baseUnits: 'L',
                precision: 2,
                removeUnitsIfDefault: true,
                allowTruncate: false,
            }
        }

        if (totalWeight && completedArea) {
            appVol = totalWeight / completedArea
            applicationVolumeWeight = {
                item: 'Avg. App Rate',
                value: appVol,
                isUOM: true,
                metricUnits: 'kg/ha',
                imperialUnits: 'lb/ac',
                baseUnits: 'kg/m2',
                precision: 2,
                removeUnitsIfDefault: true,
                allowTruncate: false,
            }
            totalProduct = {
                item: 'Total Product',
                value: totalWeight,
                isUOM: true,
                metricUnits: 'kg',
                imperialUnits: 'lb',
                baseUnits: 'kg',
                precision: 2,
                removeUnitsIfDefault: true,
                allowTruncate: false,
            }
        }

        const name = apiData.sessions[sessionIndexes[0]].product.name || DEFAULT_DISPLAY_VALUE

        return {
            applicationVolumeWeight: applicationVolumeWeight,
            totalProduct: totalProduct,
            totalVolume: totalVolume,
            totalWeight: totalWeight,
            completedArea: completedArea,
            name: name,
        }
    }

    function subheaderData(apiData, sessionIndexes, applicationVolumeWeight, completedArea) {
        // NOTE: array order affects order on page
        const subheaderInfo = []
        subheaderInfo.push({
            item: 'Application Type',
            value: (apiData.sessions[sessionIndexes[0]].product.productType || DEFAULT_DISPLAY_VALUE).replace('_', ' '),
        })
        subheaderInfo.push({
            item: 'Field Area',
            value: Number(apiData.field.area),
            isUOM: true,
            metricUnits: 'ha',
            imperialUnits: 'ac',
            precision: 2,
            allowTruncate: false,
            removeUnitsIfDefault: true,
            defaultDisplayValue: 'n/a',
        })
        if (applicationVolumeWeight && Object.keys(applicationVolumeWeight).length > 0) {
            subheaderInfo.push(applicationVolumeWeight)
        }
        subheaderInfo.push({
            item: 'Completed Area',
            value: completedArea,
            isUOM: true,
            metricUnits: 'ha',
            imperialUnits: 'ac',
            precision: 2,
            allowTruncate: false,
            removeUnitsIfDefault: true,
        })

        return subheaderInfo
    }

    function mapData(apiData, sessionIndexes, coverageMapIndex) {
        const mapData = {
            imageData: apiData.coverageMaps[coverageMapIndex].imageData,
            standardImageData: apiData.coverageMaps[coverageMapIndex].standardImageData,
            metricImageData: apiData.coverageMaps[coverageMapIndex].metricImageData,
            features: apiData.coverageMaps[coverageMapIndex].geoFeatures,
            isLiquid: (apiData.sessions[sessionIndexes[0]].product.liquid === '1'),
        }

        return mapData
    }

    function productInfoData(apiData, sessionIndexes, sessionsProduct) {
        const productData = {
            name: sessionsProduct.name,
            appRate: sessionsProduct.applicationVolumeWeight,
            totalProduct: Object.keys(sessionsProduct.totalProduct).length > 0 ? sessionsProduct.totalProduct : {item: 'Total Product', value: DEFAULT_DISPLAY_VALUE, isUOM: false, metricUnits: 'L', imperialUnits: 'gal', baseUnits: 'L', removeUnitsIfDefault: true},
            appliedArea: {item: 'Applied Area', value: sessionsProduct.completedArea, isUOM: true, metricUnits: 'ha', imperialUnits: 'ac', precision: 2, allowTruncate: false},
        }

        return productData
    }

    function ingredientData(apiData, coverageMapIndex, sessionsProduct) {
        const ingredients = []

        const product = apiData.coverageMaps[coverageMapIndex].product
        const fallbackContext = {
            ingredientCount: product.ingredients.length,
            hasCarrier: !!product.carrier,
            mixRate: Number(sessionsProduct?.applicationVolumeWeight?.value),
            mixQuantity: Number(sessionsProduct?.totalProduct?.value),
        }

        for (let j = 0; j < product.ingredients.length; j++) {
            const { rate, quantity } = resolveIngredientRateAndQuantity(product.ingredients[j], fallbackContext)
            const ingred = {
                name: product.ingredients[j].name,
                rate: rate,
                company: product.ingredients[j].company,
                quantity: quantity,
                liquid: Number(product.ingredients[j].liquid),
            }

            ingredients.push(ingred)
        }

        const ingredientRows = []
        for (let i = 0; i < ingredients.length; i++) {
            const metricUnitsRate = ingredients[i].liquid ? 'L/ha' : 'kg/ha'
            const imperialUnitsRate = ingredients[i].liquid ? 'gal/ac' : 'lb/ac'
            const baseUnitsRate = ingredients[i].liquid ? 'L/m2' : 'kg/m2'

            const metricUnitsQuantity = ingredients[i].liquid ? 'L' : 'kg'
            const imperialUnitsQuantity = ingredients[i].liquid ? 'gal' : 'lb'
            const baseUnitsQuantity = ingredients[i].liquid ? 'L' : 'kg'

            ingredientRows.push({
                rowName: {value: ingredients[i].name, defaultDisplayValue: DEFAULT_DISPLAY_VALUE},
                rate: {value: Number(ingredients[i].rate), isUOM: true, precision: 3, metricUnits: metricUnitsRate, imperialUnits: imperialUnitsRate, baseUnits: baseUnitsRate, allowTruncate: false},
                supplier: {value: ingredients[i].company, defaultDisplayValue: DEFAULT_DISPLAY_VALUE},
                totalProduct: {value: Number(ingredients[i].quantity), isUOM: true, precision: 2, metricUnits: metricUnitsQuantity, imperialUnits: imperialUnitsQuantity, baseUnits: baseUnitsQuantity, allowTruncate: false},
            })
        }

        const ingredientData = {
            ingredientRows: ingredientRows,
        }

        return ingredientData
    }
}
